import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { RecommendCardLoading } from './loading';

export const RecommendedCardsLoaders = (props) => {


    const {
        count
    } = props;


    return <div>
        <Grid container direction='row' spacing={4}>
            {
                Array.apply(null, Array(count)).map((value, index) => <Grid key={index} item xs={12} sm={6} md={3} lg={3} xl={3}>
                    <RecommendCardLoading />
                </Grid>)
            }
        </Grid>
    </div>
}

RecommendedCardsLoaders.propTypes = {
    count: PropTypes.number
}

RecommendedCardsLoaders.defaultProps = {
    count: 1
}